import type { AppState } from 'src/store';
import { createSelector } from 'reselect';
import { Lens } from 'monocle-ts';
import {
  getActiveContextPlanType,
  getActiveContext,
  getActiveContextString,
  getActivePerspectiveCartButtonConfig,
  getActivePerspectiveQuickReconButtonConfig,
  getActivePerspectiveAgentButtonConfig,
  hasContextsWithPlanTypeAllocation,
} from 'src/pages/PerspectiveSelection/PerspectiveSelection.selectors';
import { HINDSIGHTING_CONTEXT } from 'src/utils/Domain/Constants';
import { getAssortmentCartLink } from 'src/pages/AssortmentBuild/AssortmentAdd/AssortmentAddBySearch/AssortmentAddBySearch.selectors';
import { getFiltersEnabled } from 'src/pages/PerspectiveSelection/PerspectiveSelection.selectors';
import type { ScopeKeysFromContextStringSelector, StateSelection } from './Headerbar.types';

export const getScopeKeysFromContextString: ScopeKeysFromContextStringSelector = createSelector(
  [getActiveContextString],
  (activeContextString) => {
    let start = 'historyStart';
    let end = 'historyEnd';
    let scopeRangesKey = 'pastRangeList';

    if (activeContextString !== HINDSIGHTING_CONTEXT) {
      start = 'start';
      end = 'end';
      scopeRangesKey = 'rangeList';
    }

    return {
      scopeStartKey: start,
      scopeEndKey: end,
      scopeRangesKey,
    };
  },
);

function getCartCount(state: AppState) {
  return Lens.fromPath<AppState>()(['cart', 'cartItems']).get(state) || [];
}

function selectState(state: AppState): StateSelection {
  const { scope, print, filters, rightContainer } = state;
  const quickReconButtonConfig = getActivePerspectiveQuickReconButtonConfig(state);
  const cartButtonConfig = getActivePerspectiveCartButtonConfig(state);
  const agentButtonConfig = getActivePerspectiveAgentButtonConfig(state);
  const scopeKeys = getScopeKeysFromContextString(state);
  const assortmentCartLink = getAssortmentCartLink(state);
  const filtersEnabled = getFiltersEnabled(state);
  const planType = getActiveContextPlanType(state);
  const showAllocation = hasContextsWithPlanTypeAllocation(state);
  const activeContext = getActiveContext(state);

  return {
    ...scope,
    isViewPrintable: print.isViewPrintable,
    cartCount: getCartCount(state).length,
    filters,
    quickReconButtonConfig,
    rightContainer,
    cartButtonConfig,
    agentButtonConfig,
    printSizes: state.appConfig.tenantConfig.printSizes,
    planTracker: state.planTracker,
    planType,
    showAllocation,
    assortmentCartLink,
    showQuickReconcile: state.quickReconcile.showQuickReconcile,
    filtersEnabled,
    contextFilterConfig: activeContext?.filters,
    ...scopeKeys,
  };
}

export function projectState(stateSelection: StateSelection) {
  return {
    ...stateSelection,
  };
}

export default createSelector(selectState, projectState);
